import * as actionTypes from "./action-types";

export const reportVersionsAction = (data: boolean) => {
  return {
    type: actionTypes.VERSION_REPORT,
    payload: data,
  };
};
